<template>
    <ItemIndex :singular-name="singularName"
               :plural-name="pluralName"
               :item-type="indexType"
    >
        <template>
            <ItemIndexFilterNotification :show="filter.show" :type="filter.type" :term="filter.term"/>
            <v-data-table :search="searchTerm" :headers="headers" :items="items" :items-per-page="10" :loading="tableLoading">
                <template v-slot:item.name="{ item }">
                    <v-btn x-small :to="'/palette/edit/' + item.id" color="primary">
                        {{ item.name }}
                        <v-icon right x-small>fas fa-edit</v-icon>
                    </v-btn>
                </template>
                <template v-slot:item.color_1="{ item }">
                    <span class="Swatch" :style="'background-color:' + item.color_1"></span>
                </template>
                <template v-slot:item.color_2="{ item }">
                    <span class="Swatch" :style="'background-color:' + item.color_2"></span>
                </template>
                <template v-slot:item.color_3="{ item }">
                    <span class="Swatch" :style="'background-color:' + item.color_3"></span>
                </template>
                <template v-slot:item.published="{ item }">
                    <v-icon small color="primary" v-if="item.published === 1">fas fa-check-circle</v-icon>
                    <v-icon small color="error" v-else>fas fa-minus-circle</v-icon>
                </template>
            </v-data-table>
        </template>
    </ItemIndex>
</template>

<script>
import ItemIndexBoilerplate from '@/views/Admin/Config/Commonn/ItemIndexBoilerplate';
export default {
    mixins: [ItemIndexBoilerplate],

    data() {
        return {
            indexType: 'palette',
            singularName: 'Color Scheme',
            pluralName: 'Color Schemes',
            responseObject: 'palettes',
            headers: [
                {
                    text: 'Name',
                    value: 'name',
                },
                {
                    text: 'Color 1',
                    value: 'color_1',
                    sortable: false,
                    filterable: false,
                },
                {
                    text: 'Color 2',
                    value: 'color_2',
                    sortable: false,
                    filterable: false,
                },
                {
                    text: 'Color 3',
                    value: 'color_3',
                    sortable: false,
                    filterable: false,
                },
                {
                    text: 'Order',
                    value: 'order',
                },
                {
                    text: 'Published',
                    value: 'published',
                    align: 'right',
                }
            ],
        };
    },
};
</script>
<style lang="scss">
.Swatch {
    display: block;
    width: 24px;
    height: 24px;
    border-radius: 12px;
    box-shadow: 1px 1px 3px rgba(black, 0.2);
}
</style>
